export default __webpack_public_path__ + "static/media/MTcarpaEspecial_Posterior.cdf3fb1c.webp";